import React, { useContext, useEffect, useState } from 'react';
import { FiVolume2 } from 'react-icons/fi';
import { observer } from 'mobx-react';

import * as S from './RobotState.style';

import { RootStoreContext } from '../../../../App';

const RobotState = observer(() => {
	const { likuStore } = useContext(RootStoreContext);

	const currentVolume = likuStore.thisLiku?.volume ?? 0;
	const [volume, setVolume] = useState(Number(currentVolume));

	useEffect(() => {
		setVolume(Number(currentVolume));
	}, [currentVolume, likuStore.thisLiku?.uuid]);

	const isSleep = likuStore.thisLiku?.motionStatus === 'sleeping';

	const handleVolumeChange = (event) => {
		const nextVolume = Number(event.target.value);
		setVolume(nextVolume);
	};

	const applyVolume = (event) => {
		likuStore.setVolume(Number(event.currentTarget.value));
	};

	const handleVolumeKeyUp = (event) => {
		if (
			[
				'ArrowLeft',
				'ArrowRight',
				'ArrowUp',
				'ArrowDown',
				'Home',
				'End',
				'PageUp',
				'PageDown',
			].includes(event.key)
		) {
			applyVolume(event);
		}
	};

	return (
		<S.RobotStateBox className='dark'>
			<div className='title'>
				로봇 상태
				<div className='wrap'>
					<div className='stateWrap'>
						<S.VolumeControl>
							<FiVolume2 aria-hidden='true' />
							<S.VolumeSliderWrap style={{ '--volume': volume }}>
								<input
									type='range'
									aria-label='볼륨'
									min={0}
									max={100}
									step={10}
									value={volume}
									onChange={handleVolumeChange}
									onPointerDown={(event) =>
										event.currentTarget.setPointerCapture(event.pointerId)
									}
									onPointerUp={applyVolume}
									onKeyUp={handleVolumeKeyUp}
								/>
								<span className='volumeTooltip' aria-hidden='true'>
									{volume}
								</span>
							</S.VolumeSliderWrap>
						</S.VolumeControl>
						<S.StateButton
							disabled={isSleep}
							click={isSleep}
							onClick={() => likuStore.setMotionState('sleep')}>
							{isSleep ? '자는중' : '재우기'}
						</S.StateButton>
						<S.StateButton
							disabled={!isSleep}
							click={!isSleep}
							onClick={() => likuStore.setMotionState('active')}>
							{!isSleep ? '활동중' : '깨우기'}
						</S.StateButton>
					</div>
					{/*<S.VolumeButton></S.VolumeButton>*/}
				</div>
			</div>
		</S.RobotStateBox>
	);
});

export default RobotState;
